// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__ERKri","col":"styles_col__2iW_t","fulfillmentStatus":"styles_fulfillmentStatus__3UwQu","emailCol":"styles_emailCol__3XmoY"};